<template>
  <v-content>
    <AppBar title="Vändstäd" />
    <v-container :fluid="true">
      <v-card>
        <v-data-table
          :footer-props="footerProps"
          :loading="$apollo.loading"
          :headers="headers"
          :items="transformedCleaningRegistrations"
          :search="search"
          loading-text="Hämtar data..."
          no-data="Ingen data hittades..."
          no-results-text="Inget resultat på din sökning..."
          :height="tableHeight"
          :items-per-page="20"
          fixed-header
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Vändstäd</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Sök..."
                single-line
                hide-details
                filled
                dense
              ></v-text-field>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer />
              <v-dialog v-model="showExportModal" width="500">
                <template v-slot:activator="{ on }">
                  <v-btn tile v-on="on" :loading="pendingExport">
                    <v-icon small left>mdi-file-export-outline</v-icon>
                    Export Excel
                  </v-btn>
                </template>
                <ExportModal
                  v-if="showExportModal"
                  @close="showExportModal = false"
                  @confirm="exportToExcel"
                />
              </v-dialog>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import AppBar from '@/components/AppBar.vue'
import tableHeight from '@/mixins/tableHeight.js'
import gql from 'graphql-tag'
import { format } from 'date-fns'
import { exportExcel } from '@/services/exportExcel.service.js'
import ExportModal from '@/components/ExportModal'
import { isWithinInterval } from 'date-fns'
import orderBy from 'lodash.orderby'
import { get } from 'vuex-pathify'

export default {
  name: 'CleaningRegistrations',

  mixins: [tableHeight],

  components: {
    AppBar,
    ExportModal
  },

  data: () => ({
    showMenu: false,
    showUpdateModal: false,
    showExportModal: false,
    pendingExport: false,
    footerProps: {
      itemsPerPageOptions: [10, 20, 50],
      itemsPerPageText: 'Rader per sida'
    },
    search: ''
  }),

  apollo: {
    cleaning: {
      fetchPolicy: 'cache-and-network',
      query: gql`
        query {
          cleaning {
            id
            train_number
            created
            date
            requirement
            perform_at
            comment
            user
          }
        }
      `
    }
  },

  computed: {
    isSj: get('user/isSj'),

    hasAccess: get('user/hasAccess'),

    transformedCleaningRegistrations() {
      const items = (this.cleaning || []).map(x => ({
        ...x,
        date: format(new Date(x.date), 'yyyy-MM-dd'),
        created: format(new Date(x.created), 'yyyy-MM-dd HH:mm')
      }))

      return orderBy(items, ['date', 'created'], ['desc', 'desc'])
    },

    headers() {
      return [
        {
          text: 'Datum',
          value: 'date',
          width: 150
        },

        {
          text: 'Tågnr.',
          value: 'train_number'
        },
        {
          text: 'Vagn tjänstegörning',
          value: 'perform_at'
        },
        {
          text: 'Behov',
          value: 'requirement'
        },
        {
          text: 'Kommentar',
          value: 'comment'
        },
        {
          text: 'Skapad',
          value: 'created',
          width: 200
        },
        {
          text: 'Skapad av',
          value: 'user'
        },

        { text: '', value: 'actions', sortable: false, align: 'end' }
      ]
    }
  },

  methods: {
    async exportToExcel(period) {
      const filteredCleaningRegistrations = orderBy(
        this.transformedCleaningRegistrations,
        ['date', 'created'],
        ['desc', 'desc']
      ).filter(x => {
        return isWithinInterval(new Date(x.date), {
          start: new Date(period.from),
          end: new Date(period.to)
        })
      })
      this.pendingExport = true
      const filename = `Export - Vändstäd`
      const workbook = {
        name: filename,
        sheets: [
          {
            name: 'Vändstäd',
            data: filteredCleaningRegistrations.map(row => {
              return this.headers.reduce((acc, col) => {
                acc[col.text] = row[col.value]
                return acc
              }, {})
            })
          }
        ]
      }

      await exportExcel(this.$apollo.provider.defaultClient, filename, workbook)
      this.pendingExport = false
    },

    refetch() {
      this.$apollo.queries.cleaningRegistrations.refetch()
    }
  }
}
</script>
